module.exports = __webpack_public_path__ + "static/dark-logo-aeeed2f0ba60d911b788182a7cdf32f5.png";